<template>
          <BreadCrumb PageTitle=" Modifier une reclamation" />

    <EditReclamation/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditReclamation from "@/components/Reclamation/EditReclamation.vue";
  
    export default defineComponent({
      name: "EditReclamationPage",
      components: {
        BreadCrumb,
        EditReclamation,
      },
    });
  </script>